// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Context = require("../../../provider/Context.bs.js");
var Atom_Cta = require("../../atom/Atom_Cta.bs.js");
var Atom_Row = require("../../atom/Atom_Row.bs.js");
var Atom_Cell = require("../../atom/Atom_Cell.bs.js");
var UseOnBlur = require("../../../hook/UseOnBlur.bs.js");
var UseToggle = require("../../../hook/UseToggle.bs.js");
var Util_I18n = require("../../../util/Util_I18n.bs.js");
var Atom_Image = require("../../atom/Atom_Image.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Emac_Menus = require("../../../emac/Emac_Menus.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Header = require("../../../type/Type_Header.bs.js");
var Type_String = require("../../../type/Type_String.bs.js");
var Atom_Divider = require("../../atom/Atom_Divider.bs.js");
var Context_I18n = require("../../../provider/Context_I18n.bs.js");
var UseUserAgent = require("../../../hook/UseUserAgent.bs.js");
var User_Provider = require("../../../user/User_Provider.bs.js");
var Util_Debounce = require("../../../util/Util_Debounce.bs.js");
var Particle_zIndex = require("../../particle/Particle_zIndex.bs.js");
var UseClickOutside = require("../../../hook/UseClickOutside.bs.js");
var Layout_Constants = require("../../layout/Layout_Constants.bs.js");
var Molecule_Message = require("../../molecule/Molecule_Message.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../../particle/Particle_Spacer_Ds.bs.js");
var UseScreenResolution = require("../../../hook/UseScreenResolution.bs.js");
var Organism_LoginButton = require("./Organism_LoginButton.bs.js");
var Type_Mona_Navigation = require("../../../type/Type_Mona_Navigation.bs.js");
var Organism_Header_Panel = require("./Organism_Header_Panel.bs.js");
var Organism_SettingsMenu = require("./Organism_SettingsMenu.bs.js");
var Particle_Background_Ds = require("../../particle/Particle_Background_Ds.bs.js");
var Organism_BaseNavigation = require("./base/Organism_BaseNavigation.bs.js");
var Molecule_LanguageSwitcher = require("../../molecule/Molecule_LanguageSwitcher.bs.js");
var Organism_SearchNavigation = require("./Organism_SearchNavigation.bs.js");
var Particle_Screen_Constants = require("../../particle/Particle_Screen_Constants.bs.js");
var Organism_ConcertNavigation = require("./concert/Organism_ConcertNavigation.bs.js");
var Organism_Concert_SocialLinks = require("./concert/Organism_Concert_SocialLinks.bs.js");
var Organism_HeaderRedirectionAnchor = require("./Organism_HeaderRedirectionAnchor.bs.js");

var id = "welcome";

function Organism_Header$SubHeader$Welcome(Props) {
  var match = Context.I18n.getState(undefined);
  var labels = match.labels;
  var match$1 = labels.accessibility;
  var match$2 = labels.common;
  return React.createElement(Molecule_Message.make, {
              variant: "subHeader",
              text: match$2.subHeader,
              closeLabel: match$1.closeSubheader,
              id: id,
              storage: /* Stored */0
            });
}

var Welcome = {
  id: id,
  storage: /* Stored */0,
  make: Organism_Header$SubHeader$Welcome
};

var id$1 = "fsk";

function Organism_Header$SubHeader$Fsk(Props) {
  var userStatus = User_Provider.Hook.useTokenStatus(undefined);
  var ffFskSubHeaderAllUser = Context.Config.getFeatureFlippingStatus(/* FskSubHeaderAllUser */10);
  var match = Context.I18n.getState(undefined);
  var labels = match.labels;
  var match$1 = labels.accessibility;
  var match$2 = labels.common;
  if (ffFskSubHeaderAllUser && userStatus < 3) {
    return null;
  }
  return React.createElement(Molecule_Message.make, {
              variant: "subHeader",
              text: match$2.fskSubHeader,
              closeLabel: match$1.closeSubheader,
              id: id$1,
              storage: /* Stored */0,
              linkLabel: match$2.fskSubHeaderLink,
              linkUrl: Type_Mona_Navigation.Profile.makeHref(match.locale, "profile"),
              linkPosition: /* End */0
            });
}

var Fsk = {
  id: id$1,
  storage: /* Stored */0,
  make: Organism_Header$SubHeader$Fsk
};

function getById(id) {
  if (id === "Fsk") {
    return Caml_option.some(React.createElement(Organism_Header$SubHeader$Fsk, {}));
  } else {
    return Caml_option.some(React.createElement(Organism_Header$SubHeader$Welcome, {}));
  }
}

var SubHeader = {
  Welcome: Welcome,
  Fsk: Fsk,
  getById: getById
};

function Organism_Header$InstallMobileApp(Props) {
  var appUrl = Props.appUrl;
  var installApp = Props.installApp;
  var searchState = Props.searchState;
  var display = Particle_Screen_Ds.make(undefined, undefined, undefined, "none", undefined, searchState ? "flex" : "none");
  return React.createElement(Atom_Cta.Link.make, {
              href: appUrl,
              label: installApp,
              style: {
                TAG: /* Header */10,
                _0: {
                  TAG: /* InstallMobileApp */4,
                  _0: display
                }
              }
            });
}

var InstallMobileApp = {
  make: Organism_Header$InstallMobileApp
};

function Organism_Header(Props) {
  var forcedUserStatus = Props.forcedUserStatus;
  var category = Props.category;
  var oneTimeEventOpt = Props.oneTimeEvent;
  var logoBerneOpt = Props.logoBerne;
  var modeOpt = Props.mode;
  var search = Props.search;
  var isFixedOpt = Props.isFixed;
  var languages = Props.languages;
  var onClick = Props.onClick;
  var displayedSubHeadersOpt = Props.displayedSubHeaders;
  var menuItems = Props.menuItems;
  var oneTimeEvent = oneTimeEventOpt !== undefined ? Caml_option.valFromOption(oneTimeEventOpt) : undefined;
  var logoBerne = logoBerneOpt !== undefined ? logoBerneOpt : false;
  var mode = modeOpt !== undefined ? modeOpt : "replay";
  var isFixed = isFixedOpt !== undefined ? isFixedOpt : true;
  var displayedSubHeaders = displayedSubHeadersOpt !== undefined ? displayedSubHeadersOpt : [];
  var match = Context.Config.getState(undefined);
  var match$1 = Context.I18n.getState(undefined);
  var locale = match$1.locale;
  var match$2 = Context.Config.getState(undefined);
  var data = Emac_Menus.toDsNavigation(menuItems, undefined);
  var ffNewConcertHeader = Context.Config.getFeatureFlippingStatus(/* NewConcertHeader */11);
  var ffUserPanel = Context.Config.getFeatureFlippingStatus(/* UserPanel */7);
  var languageSwitcherBehavior = onClick !== undefined ? /* Button */({
        _0: onClick
      }) : /* Link */0;
  var settings = data.Settings;
  var concert = data.Concert;
  var logoNavigation = data.LogoNavigation;
  var searchNavigation = data.SearchNavigation;
  var club = data.Club;
  var match$3 = search !== undefined ? [
      search.isOpen ? /* On */0 : /* Off */1,
      search.onOpen,
      search.onClose,
      search.placeholder,
      Util_Debounce.make(search.onChange, search.debounce),
      search.searchBarStatus,
      search.initialQuery
    ] : [
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      "dynamic",
      undefined
    ];
  var match$4 = UseToggle.make(match$3[0], match$3[1], match$3[2], undefined);
  var searchState = match$4.state;
  var searchRef = React.useRef(null);
  var closeSearch = match$3[5] === "dynamic" ? match$4.close : (function (param) {
        
      });
  var consentStatus = match$2.api.consentStatus;
  var subHeaders = consentStatus === "unset" || consentStatus === "unknown" ? null : Belt_Array.keepMap(displayedSubHeaders, getById);
  UseClickOutside.make(searchRef, closeSearch);
  UseOnBlur.make(searchRef, closeSearch);
  var renderOneTimeEvent;
  if (oneTimeEvent !== undefined) {
    var redirectLink = oneTimeEvent.redirectLink;
    renderOneTimeEvent = React.createElement(Atom_Cell.make, {
          justifyContent: Particle_Screen_Constants.justifyContentCenter,
          children: React.createElement(Atom_Cta.Link.Block.make, {
                children: React.createElement(Atom_Image.ImageTmp.make, {
                      alt: redirectLink.label,
                      autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                      src: oneTimeEvent.imageSrc,
                      style: /* PromotionalLogo */13
                    }),
                href: redirectLink.href,
                style: {
                  TAG: /* Header */10,
                  _0: /* OneTimeEvent */2
                },
                target: "Blank"
              }),
          rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.flexGrow(2)])
        });
  } else {
    renderOneTimeEvent = null;
  }
  var country = Util_I18n.isEurope(locale) ? /* Europe */0 : /* Default */1;
  var navigation;
  if (mode === "concert") {
    navigation = React.createElement(Organism_ConcertNavigation.make, {
          labels: concert,
          country: country,
          logoNavigation: logoNavigation,
          searchState: searchState,
          logoBerne: logoBerne
        });
  } else {
    var tmp = {
      menuNavigation: data.MenuNavigation,
      desktopNavigation: data.DesktopNavigation,
      country: country,
      logoNavigation: logoNavigation,
      searchState: searchState,
      logoBerne: logoBerne
    };
    if (category !== undefined) {
      tmp.category = Caml_option.valFromOption(category);
    }
    navigation = React.createElement(Organism_BaseNavigation.make, tmp);
  }
  var socialRules = Particle_Screen_Ds.make(undefined, undefined, [CssJs.display("flex")], undefined, undefined, [CssJs.display("none")]);
  var zIndexRule = Particle_zIndex.Particle_zIndex_Css.toCss({
        TAG: /* Exact */0,
        _0: /* Header */7
      });
  var positionRule = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, isFixed ? [
          CssJs.position(CssJs.fixed),
          zIndexRule,
          CssJs.top(CssJs.px(0)),
          CssJs.left(CssJs.pct(50)),
          CssJs.transform({
                NAME: "translateX",
                VAL: CssJs.pct(-50)
              })
        ] : []);
  var userAgentState = UseUserAgent.make(undefined);
  var playStoreUrl = Belt_Option.map(match.playStoreUrl, Type_String.PlayStoreUrl.toString);
  var appStoreUrl = Belt_Option.map(match.appStoreUrl, Type_String.AppStoreUrl.toString);
  var appUrl;
  if (userAgentState !== undefined) {
    var match$5 = userAgentState.platform;
    appUrl = match$5 !== 1 ? (
        match$5 !== 0 ? undefined : playStoreUrl
      ) : appStoreUrl;
  } else {
    appUrl = undefined;
  }
  var centerRightLinks = mode === "concert" ? (
      ffNewConcertHeader ? null : React.createElement(React.Fragment, undefined, React.createElement(Atom_Row.make, {
                  children: null,
                  rules: socialRules
                }, React.createElement(Organism_Concert_SocialLinks.make, {
                      socialNetworks: concert.socialNetworks
                    }), React.createElement(Atom_Cell.make, {
                      blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVertical("S")),
                      children: React.createElement(Atom_Divider.make, {
                            style: Atom_Divider.headerSocialLink
                          })
                    })))
    ) : (
      oneTimeEvent !== undefined || appUrl === undefined ? null : React.createElement(Organism_Header$InstallMobileApp, {
              appUrl: appUrl,
              installApp: data.InstallApp,
              searchState: searchState
            })
    );
  var screenSize = UseScreenResolution.make({
        NAME: "L",
        VAL: 0
      }, undefined);
  var userButton;
  if (ffUserPanel) {
    var tmp$1 = {
      labels: club,
      searchState: searchState,
      settingsHref: settings.href
    };
    if (forcedUserStatus !== undefined) {
      tmp$1.forcedUserStatus = Caml_option.valFromOption(forcedUserStatus);
    }
    userButton = React.createElement(Organism_LoginButton.make, tmp$1);
  } else {
    var exit = 0;
    if (typeof screenSize === "object" && screenSize.NAME === "L") {
      var tmp$2 = {
        labels: club,
        searchState: searchState,
        settingsHref: settings.href
      };
      if (forcedUserStatus !== undefined) {
        tmp$2.forcedUserStatus = Caml_option.valFromOption(forcedUserStatus);
      }
      userButton = React.createElement(Organism_LoginButton.make, tmp$2);
    } else {
      exit = 1;
    }
    if (exit === 1) {
      userButton = React.createElement(Organism_Header_Panel.make, {
            forcedUserStatus: forcedUserStatus,
            userLabels: club,
            searchState: searchState,
            settings: settings
          });
    }
    
  }
  var tmp$3 = {
    searchNavigation: searchNavigation,
    placeholder: match$3[3],
    initialQuery: match$3[6],
    state: searchState,
    toggle: match$4.toggle
  };
  var tmp$4 = match$3[4];
  if (tmp$4 !== undefined) {
    tmp$3.onChange = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = {
    locale: locale,
    labels: data.Languages,
    searchState: searchState,
    mode: mode,
    languageSwitcherBehavior: languageSwitcherBehavior,
    ffNewConcertHeader: ffNewConcertHeader
  };
  var tmp$6 = Belt_Option.map(languages, Context_I18n.ensureAlternativeLanguages);
  if (tmp$6 !== undefined) {
    tmp$5.alternativeLanguages = Caml_option.valFromOption(tmp$6);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Row.make, {
                  background: Particle_Background_Ds.header,
                  children: null,
                  height: Type_Header.Constants.heightStyle,
                  justifyContent: Particle_Screen_Constants.justifyContentSpaceBetween,
                  kind: /* Header */3,
                  maxWidth: Layout_Constants.maxWidthMainContentScreen,
                  rules: positionRule,
                  width: Particle_Screen_Constants.oneHundredPctWidth,
                  wrap: /* OnOneLine */1
                }, React.createElement(Organism_HeaderRedirectionAnchor.make, {
                      labels: data.RedirectionAnchor,
                      searchNavigation: searchNavigation
                    }), React.createElement(Atom_Row.make, {
                      background: Particle_Background_Ds.header,
                      blockSpace: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeHorizontal("M")), undefined, undefined, Particle_Spacer_Ds.makeNone(undefined)),
                      children: null,
                      height: Type_Header.Constants.heightStyle,
                      width: Particle_Screen_Constants.oneHundredPctWidth,
                      wrap: /* OnOneLine */1
                    }, navigation, React.createElement(Atom_Row.make, {
                          alignItems: Particle_Screen_Constants.alignItemsCenter,
                          autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                          children: null,
                          justifyContent: Particle_Screen_Constants.justifyContentFlexEnd,
                          wrap: /* OnOneLine */1,
                          ref_: searchRef
                        }, renderOneTimeEvent, centerRightLinks, React.createElement(Organism_SettingsMenu.Button.make, {
                              href: settings.href
                            }), React.createElement(Organism_SearchNavigation.make, tmp$3), userButton, React.createElement(Molecule_LanguageSwitcher.make, tmp$5)))), subHeaders);
}

var make = Organism_Header;

exports.SubHeader = SubHeader;
exports.InstallMobileApp = InstallMobileApp;
exports.make = make;
/* CssJs Not a pure module */
